// Default settings structure
const DEFAULT_SETTINGS = {
  country: 'BE',
  gasPriceType: 'fixed',
  gasPrice: '75',
  co2PriceType: 'live',
  co2Price: '',
  eBoilerEff: '95',
  gasBoilerEff: '90',
  gridCost: '0.12',
};

const SETTINGS_KEY = 'leadgen_settings';
const USER_INFO_KEY = 'user_info';

export const getUserInfo = (key) => {
  const userInfo = localStorage.getItem(USER_INFO_KEY);
  return userInfo ? JSON.parse(userInfo)[key] : null;
};

export const updateUserInfo = (key, value) => {
  const userInfo = localStorage.getItem(USER_INFO_KEY);
  const parsedUserInfo = userInfo ? JSON.parse(userInfo) : {};
  parsedUserInfo[key] = value;
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(parsedUserInfo));
};



export const getUserSettings = () => {
  try {
    const settings = localStorage.getItem(SETTINGS_KEY);
    return settings ? JSON.parse(settings) : null;
  } catch (error) {
    console.error('Error reading settings from localStorage:', error);
    return null;
  }
};

export const updateUserSettings = (settings) => {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
    return true;
  } catch (error) {
    console.error('Error saving settings to localStorage:', error);
    return false;
  }
};

export const resetUserSettings = () => {
  try {
    localStorage.setItem('userSettings', JSON.stringify(DEFAULT_SETTINGS));
    return DEFAULT_SETTINGS;
  } catch (error) {
    console.error('Error resetting user settings:', error);
    return DEFAULT_SETTINGS;
  }
}; 